export enum PlanAndRateOverrideRuleStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export type PlanAndRateOverrideRuleTemplateKey =
  | 'UPSERT_RULE'
  | 'PARTIAL_FIELD_UPDATE'

export enum PlanAndRateOverrideValueSource {
  REAL_DATA = 'REAL_DATA',
  IDEON_DATA = 'IDEON_DATA',
  OVERRIDE_DATA = 'OVERRIDE_DATA',
}
